<script setup lang="ts">
import ObjectView from '@/views/ObjectView.vue';
</script>

<template>
  <ObjectView />
</template>
